export default {
  methods: {
    gatewayPrefix(index) {
      if (this.$i18n.locale === 'de-DE') {
        return index === 0 ? '' : 'Auch';
      } else {
        return index === 0 ? 'Te' : 'Ook te';
      }
    },
    formatMinutes(min) {
      const hours = Math.trunc(parseInt(min) / 60);
      const minutes = parseInt(min) % 60;

      return (
        hours.toString().padStart(2, 0) +
        ':' +
        minutes.toString().padStart(2, 0)
      );
    }
  }
};
